<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card>
                    <b-form-group
                        :label="$t('id')"
                        :description="$t('ratchetIdDescription')"
                    >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('id')">
                            <b-form-input v-model="connectionId"></b-form-input>
                        </protokol-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                        :label="$t('type')"
                    >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('type')">
                            <v-select :options="connectionTypes" v-model="model.type" />
                        </protokol-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                        :label="$t('credentials')"
                    >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('credentials.type')">
                            <v-select :options="credentialsType" v-model="model.credentials.type" />
                        </protokol-invalid-feedback>
                    </b-form-group>

                    <template v-if="model.credentials.type == 'DSN'">
                        <b-form-group
                            label="DSN"
                        >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('credentials.dsn')">
                            <b-form-input v-model="model.credentials.dsn" />
                        </protokol-invalid-feedback>
                        </b-form-group>
                    </template>

                    <template v-if="model.credentials.type == 'Credentials'">
                        <b-form-group
                            label="User"
                        >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('credentials.user')">
                            <b-form-input v-model="model.credentials.user" />
                        </protokol-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                            label="Password"
                        >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('credentials.password')">
                            <b-form-input type="password" v-model="model.credentials.password" />
                        </protokol-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                            label="Host"
                        >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('credentials.host')">
                            <b-form-input v-model="model.credentials.host" />
                        </protokol-invalid-feedback>
                            
                        </b-form-group>

                        <b-form-group
                            label="DB name"
                        >
                        <protokol-invalid-feedback :errors="validator.fieldErrors('credentials.dbname')">
                            <b-form-input v-model="model.credentials.dbname" />
                        </protokol-invalid-feedback>
                        </b-form-group>
                    </template>

                    <b-card-footer>
                        <b-button variant="success" class="mr-1" @click="save"> {{ $t('save') }}</b-button>
                        <b-button variant="warning" @click="testConnection"> {{ $t('testConnection') }}
                        </b-button>
                    </b-card-footer>
                </b-card>    
            </b-col>

            <b-col cols="12" md="3" v-for="query in model.queries" :key="query.id">
                <b-card>
                    <b-row>
                        <b-col cols="8">{{ query.id }}</b-col>
                        <b-col cols="4"> <b-icon icon="pencil" class="mr-2 action" @click="editAction(query)"/> <b-icon icon="trash" class="action" /></b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import VSelect from 'vue-select'
import CodeEditor from '@/components/form/Editor/Code.vue'

export default {
    name: "CreateRatchet",
    components: {
        VSelect,
        CodeEditor,
    },
    data: function() {
        return {
            model: {
                id: '',
                type: null,
                credentials: {
                    type: null,
                    dsn: null,
                    user: null,
                    password: null,
                    host: null,
                    dbname: null
                },
                queries: []
            },


            edit: {
                active: false,
                query: {
                    id: '',
                    expression: null
                }
            },

            create: {
                active: false,
                query: {
                    id: '',
                    expression: null
                }
            },

            connectionTypes: ['MySQL', 'PostgreSQL', 'MongoDB'],

            errors: {
                id: null,
                type: null,
                credentials: {
                    type: null,
                    dsn: null,
                    user: null,
                    password: null,
                    host: null,
                    dbname: null
                }
            },

            validator: this.$validator()
        }
    },

    watch: {
        model: {
            handler: function() {
                this.validator.revalidate()
            },

            deep: true
        },
    },

    computed: {
        connectionId:{
            get() {
                return this.model.id.replaceAll(" ", "_")
            },

            set(v) {
                this.model.id = v.replaceAll(" ", "_")
            }
        },

        credentialsType() {
            if (this.model.type == 'MongoDB') return ['DSN']

            return ['DSN', 'Credentials']
        }
    },

    methods: {
        testConnection() {
            this.$ratchetApi.post("/test/connection", this.model).then(resp => {
                this.$bvToast.toast(this.$t('connectionEstablished'), {
                    title: this.$t('success'),
                    variant: 'success'
                })
            }).catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            })
        },

        save() {
            if (!this.validator.pass()) return

            let popup = this.$loadingPopup()
            this.$ratchetApi.post("/connection", this.model).then(resp => {
                this.$router.push("/admin/ratchet/edit/" + this.model.id)
            }).catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        },

        validate() {
            const model = this.model

            if (!model.id) this.errors.id = this.$t('fieldRequired')
            if (!model.id) this.errors.type = this.$t('fieldRequired')
        }
    },

    created() {
        this.validator.validate(this.model, {
            idAndType: (model, errors) => {
                if (!model.id) errors.add('id', [this.$t('fieldRequired')])
                if (!model.type) errors.add('type', [this.$t('fieldRequired')])

                return errors
            },

            credentials: (model, errors) => {
                if (!model.credentials.type) errors.add('credentials.type', [this.$t('fieldRequired')])

                if (model.credentials.type == 'Credentials') {
                    if (!model.credentials.user) errors.add('credentials.user', [this.$t('fieldRequired')])   
                    if (!model.credentials.password) errors.add('credentials.password', [this.$t('fieldRequired')])  
                    if (!model.credentials.host) errors.add('credentials.host', [this.$t('fieldRequired')]) 
                    if (!model.credentials.dbname) errors.add('credentials.dbname', [this.$t('fieldRequired')])
                }

                if (model.credentials.type == 'DSN') {
                    if (!model.credentials.dsn) errors.add('credentials.dsn', [this.$t('fieldRequired')])
                }
            }
        })
    }
}
</script>

<style scoped>
.action {
    cursor: pointer;
}

.action:hover {
    color: #ccc;
}

</style>